import { getType } from 'typesafe-actions';

import { NetworkRequestState } from '@bolteu/redux-session';

import {
  requestAccountCampaignInfoAsyncAction,
  requestAccountInfoAsyncAction,
  selectProviderAction,
} from 'rdx/account/actions';
import { GlobalAppActions } from 'rdx/actions';

import { GetProviderPortalAccountInfoResponse } from './types';

export interface AccountState {
  requestState: NetworkRequestState;
  details?: GetProviderPortalAccountInfoResponse;
  campaignDetailsRequestState?: NetworkRequestState;
  selectedProvider?: number;
  selectedVendor?: number;
}

export const accountReducer = (
  state: AccountState = {
    requestState: NetworkRequestState.unset,
    campaignDetailsRequestState: NetworkRequestState.unset,
  },
  action: GlobalAppActions,
): AccountState => {
  const accountDetails = state?.details;
  switch (action.type) {
    case getType(requestAccountInfoAsyncAction.request):
      return {
        ...state,
        requestState: NetworkRequestState.waiting,
      };
    case getType(requestAccountInfoAsyncAction.success):
      return {
        ...state,
        requestState: NetworkRequestState.success,
        details: action.payload,
      };
    case getType(requestAccountInfoAsyncAction.failure):
      return {
        ...state,
        requestState: NetworkRequestState.failure,
      };
    case getType(requestAccountCampaignInfoAsyncAction.request):
      return {
        ...state,
        campaignDetailsRequestState: NetworkRequestState.waiting,
      };
    case getType(requestAccountCampaignInfoAsyncAction.success):
      if (accountDetails?.account_info?.assignments) {
        const updatedAssignments = accountDetails.account_info.assignments.map((assignment) => {
          const providerID = assignment.provider_id;
          const updatedCampaignSettings = {
            ...assignment.campaigns_settings,
            ...action.payload[providerID],
          };
          return {
            ...assignment,
            campaigns_settings: updatedCampaignSettings,
          };
        });

        return {
          ...state,
          campaignDetailsRequestState: NetworkRequestState.success,
          details: {
            ...accountDetails,
            account_info: {
              ...accountDetails.account_info,
              assignments: updatedAssignments,
            },
          },
        };
      }
      return state;
    case getType(requestAccountCampaignInfoAsyncAction.failure):
      return {
        ...state,
        campaignDetailsRequestState: NetworkRequestState.failure,
      };
    case getType(selectProviderAction):
      return {
        ...state,
        selectedProvider: action.payload,
      };
    default:
      return state;
  }
};
